import React from "react";
import balloon from "assets/images/icons/dashboard/balloon-logo.svg";
import { NsKey } from "enums/NsKey";
import { useDynamicTranslation } from "hooks/useDynamicTranslation";

interface StatusPageButtonConfig {
  label: string;
  onClick?: () => void;
}

type StatusPageSuccessProps = {
  title: string,
  description: string,
  prev?: StatusPageButtonConfig,
  next?: StatusPageButtonConfig,
};

const StatusPageSuccess: React.FC<StatusPageSuccessProps> = ({ title, description, prev, next }) => {
  const {t} = useDynamicTranslation([NsKey.ActorForm, NsKey.Common, NsKey.RealEstate])
  return (
    <div className="max-w1300 mg-0-auto ccc-body-step-5">
      <div className="flex flex-col gap-4 items-center justify-center cccbs5r1">
        <img src={balloon} alt="balloon"></img>
        <p className="text-xl font-bold">
          {t(title)}
        </p>
        <p className="text-dark-light">
          {t(description)}
        </p>
        <div className="d-flex flex-direction-col flex-ver-center">
          {
            next &&
            <button
              className=" mg-b10 pr-db-button bt-primary font-w700 min-w270"
              onClick={() => next.onClick && next.onClick()}
            >
              {t(next.label)}
            </button>
          }
          {
            prev &&
            <button
              className="mg-b60 pr-db-button-cancel min-w270"
              onClick={() => prev.onClick && prev.onClick()}
            >
              {t(prev.label)}
            </button>
          }
        </div>
      </div>
    </div>
  );
};

export default StatusPageSuccess;
